import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-connect.manage.overview', {
        url: '/overview',
        component: 'companySaaspassConnectManageOverview',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/overview/overview.state.js